import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {showRankingHelpDialog} from '../../../main/showRankingHelpDialog';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {OutlinedTabItem} from '../OutlinedTabItem/OutlinedTabItem';
import {TabType} from '../OutlinedTabItem/OutlinedTabItemProps.interface';
import {MainRankingGenreTabProps} from './MainRankingGenreTabProps.interface';

export function MainRankingGenreTab({
  isMobile,
  rankingGenreItemList,
  selectedItemParam,
  dateStr,
  onClickTabItem,
  className,
  ...props
}: MainRankingGenreTabProps) {
  return (
    <div
      className={twMerge(
        'flex h-44pxr w-full items-center justify-between bg-theme-bg-base pl-10pxr pr-15pxr',
        className
      )}
      {...props}
    >
      <div className="flex shrink-0 items-center">
        {rankingGenreItemList.map(item => (
          <OutlinedTabItem
            key={item.param}
            isActive={item.param === selectedItemParam}
            type={TabType.Background}
            className="shrink-0"
            {...putTiaraObjectProps({
              click: {
                copy: item.name,
              },
            })}
            onClick={e =>
              LOG_CLICK_EVENT('카테고리_클릭', e, () => {
                onClickTabItem?.(item.param);
              })
            }
          >
            {item.name}
          </OutlinedTabItem>
        ))}
      </div>
      {dateStr && (
        <div
          className="flex cursor-pointer items-center space-x-4pxr"
          onClick={() => {
            showRankingHelpDialog({isMobile});
          }}
        >
          <Text className="font-small2 ml-8pxr text-ellipsis text-theme-solid-60 line-clamp-1">
            {dateStr}
          </Text>
          <Icon type={IconType.ButtonHelpS} />
        </div>
      )}
    </div>
  );
}
